import { input } from './inputConstants';
import { date } from './dateConstants';

export const constants = {
    date,
    input,
};